import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control } from "react-hook-form";
import { FormValues, TranslationType } from "../types";

interface EmailFieldProps {
  control: Control<FormValues>;
  t: TranslationType;
  defaultValue?: string;
  userEmail?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any;
  locked?: boolean;
}

export const EmailField = ({
  control,
  t,
  defaultValue = "",
  userEmail,
  register: _register,
  errors: _errors,
  locked = false,
}: EmailFieldProps) => {
  const resolvedDefault = userEmail ?? defaultValue;
  // Check if it's an anonymous email and don't display it
  const isAnonymousEmail = resolvedDefault?.includes("anonymous-");

  return (
    <FormField
      control={control}
      name="email"
      rules={{
        required: t.emailRequired || "Email is required",
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: t.emailInvalid || "Please enter a valid email address",
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t.email}</FormLabel>
          <FormControl>
            <Input
              type="email"
              placeholder={t.emailPlaceholder}
              {...field}
              value={
                isAnonymousEmail
                  ? field.value.replace(/^anonymous-.*@example\.com$/, "")
                  : field.value
              }
              autoComplete="email"
              readOnly={locked}
              className={
                locked ? "bg-gray-50 text-gray-500 cursor-default" : ""
              }
            />
          </FormControl>
          {!locked && <FormMessage />}
        </FormItem>
      )}
    />
  );
};
